import { nursingHomeManager } from '$domain/model/nursingHome/nursingHome.manager'

export const getProfessionalSelectionSearchServiceList = (textFilter: string) =>
  nursingHomeManager.findProfessionalSelectionSearchServiceList(textFilter)



// WEBPACK FOOTER //
// ./src/services/nursingHome/professionalSelection/professionalSelectionSearch/getProfessionalSelectionSearchServiceList.ts